<div *ngIf="excelContext" class="upload-modal-wrpr">
  <ui-upload-file
    (uploadFileEvent)="uploadFile($event)"
    (downloadFileEvent)="downloadFile()"
    (closeEvent)="closeModal()"
  ></ui-upload-file>
</div>
